/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {
  getStatisticsMiz343,
  getMaksamMonitoringOfObjects,
  getMaksamPollutionStats,
  getStatistics,
  getStatisticsReport,
  getStatisticsReportmiz
} from '@/api/statistics'

export default {
  fetchStatisticsMiz343({commit}, params) {
    return new Promise((resolve, reject) => {
      getStatisticsMiz343(params).then(res => {
        commit('SET_STATISTICS_MIZ_343', res.data.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchMaksamMonitoringOfObjects({commit}, params) {
    return new Promise((resolve, reject) => {
      getMaksamMonitoringOfObjects(params).then(res => {
        commit('SET_MAKSAM_MONITORING_OF_OBJECTS', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchMaksamPollutionStats({commit}, params) {
    return new Promise((resolve, reject) => {
      getMaksamPollutionStats(params)
        .then(res => {
          commit('SET_MAKSAM_POLLUTION_STATS', res.data)
          resolve(res)
        }).catch(err => {
        reject(err)
      })
    })
  },

  fetchStatistics({commit}, params) {
    return getStatistics(params)
      .then((res) => {
        commit("SET_STATISTICS", res.data)
      })
  },

  fetchStatisticsReport({commit}, params) {
    return getStatisticsReport(params)
      .then((res) => {
        commit("SET_STATISTICS_REPORT", res.data)
      })
  },


  fetchStatisticsReportmiz({commit}, params) {
    return getStatisticsReportmiz(params)
      .then((res) => {
        commit("SET_STATISTICS_REPORT_MIZ", res.data)
      })
  }
}
